export default "__VITE_ASSET__CzvIRSlo__"